import React, { useState } from "react";
import { postData } from "../store/utils";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";

const AddFinancier = () => {
  const history = useHistory();
  const [submittedData, setSubmittedData] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [formData, setFormData] = useState({
    nameNBFC: "",
    addressNBFC: "",
    LogoNBFC: "",
    grivenceName: "",
    grivenceEmail: "",
    grivenceMobileno: "",
    grivenceAddress: "",
    priority: "",
    isApprovalNeeded: "No",
    maxOrderApprovalAmount: "",
  });

  const priorityOptions = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
  ];

  const approvalNeededOptions = [
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleLogoChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64URL = reader.result;
        const logo = base64URL.split(",")[1];
        setFormData({
          ...formData,
          LogoNBFC: logo,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const filteredData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) => value !== null)
    );
    console.log("Form Data", filteredData);

    if (validateForm()) {
      setIsLoadingOn(true);
      const res = await postData(`users/insertFinancierData`, filteredData);
      setIsLoadingOn(false);
      if (res.statusCode == 200) {
        history.push("/Financier");
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Data Inserted successfully!",
        });
      }
      else{
        Swal.fire({
          icon: "Error!",
          title: "Error!",
          text: res?.data?.errors.msg || "Something went wrong!!!"
        });
      }
      setErrors({});
    }
  };
  const validateForm = () => {
    const errors = {};

    if (!formData.nameNBFC) {
      errors.nameNBFC = "NBFC Name is required";
    }
    if (!formData.addressNBFC) {
      errors.addressNBFC = "NBFC Address is required ";
    }
    if (!formData.LogoNBFC) {
      errors.LogoNBFC = "Brand logo is required ";
    }
    if (!formData.grivenceName) {
      errors.grivenceName = "Grievance Officer Name is required";
    }
    if (!formData.priority) {
      errors.priority = "Priority is required";
    }
    if (!formData.maxOrderApprovalAmount) {
      errors.maxOrderApprovalAmount = "Maximum Order Approval Amount is required";
    }
    if (!formData.grivenceEmail) {
      errors.grivenceEmail = "Grievance Officer Email is required";
    }
    if (!formData.grivenceMobileno) {
      errors.grivenceMobileno = "Grievance Officer Contact is required";
    }
    if (!formData.grivenceAddress) {
      errors.grivenceAddress = "Grievance Officer Address is required";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };
  return (
    <div className="container">
      <h3 className="programHead">Add Financier</h3>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <h4 className="programDetailsDekho">NBFC Details</h4>
          <hr />

          <div className="col-md-6 changeProductPro">
            <div className="mb-3">
              <label htmlFor="creditLimit" className="form-label">
                NBFC Name<span>*</span>
              </label>
              <input
                type="text"
                placeholder="Enter NBFC Name"
                className="form-control"
                id="name"
                name="nameNBFC"
                value={formData.nameNBFC}
                onChange={handleChange}
                aria-describedby="textHelp"
              />
              {errors.nameNBFC && (
                <div className="text-danger">{errors.nameNBFC}</div>
              )}
            </div>
          </div>

          <div className="col-md-6 changeProductPro">
            <div className="mb-3">
              <label htmlFor="creditLimit" className="form-label">
                Brand Logo<span>*</span>
              </label>
              <input
                type="file"
                accept="image"
                placeholder="Enter"
                className="form-control"
                name="LogoNBFC"
                onChange={handleLogoChange}
                aria-describedby="textHelp"
              />
              {errors.LogoNBFC && (
                <div className="text-danger">{errors.LogoNBFC}</div>
              )}
            </div>
          </div>

          <div className="col-md-6 changeProductPro">
            <div className="mb-3">
              <label htmlFor="creditLimit" className="form-label">
                Priority <span>*</span>
              </label>
              <Select
                placeholder="Select Priority"
                name="priority"
                required
                options={priorityOptions}
                value={priorityOptions.find(option => option.value === formData.priority)}
                onChange={(selectedOption) =>
                  setFormData({
                    ...formData,
                    priority: selectedOption.value,
                  })
                }
              />
              {errors.priority && (
                <div className="text-danger">{errors.priority}</div>
              )}
            </div>
          </div>

          <div className="col-md-6 changeProductPro">
            <div className="mb-3">
              <label htmlFor="creditLimit" className="form-label">
                Approval Needed <span>*</span>
              </label>
              <Select
                placeholder="Select Approval Needed"
                name="approvalNeeded"
                defaultValue={approvalNeededOptions.find(option => option.value === 2)}
                required
                options={approvalNeededOptions}
                value={approvalNeededOptions.find(option => option.label === formData.isApprovalNeeded)}
                onChange={(selectedOption) =>
                  setFormData({
                    ...formData,
                    isApprovalNeeded: selectedOption.value === 1 ? "Yes" : "No",
                  })
                }
              />
              {errors.isApprovalNeeded && (
                <div className="text-danger">{errors.isApprovalNeeded}</div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 changeProductPro">
            <div className="mb-3">
              <label htmlFor="creditLimit" className="form-label">
                Address <span>*</span>
              </label>
              <textarea
                placeholder="Enter Address"
                className="form-control"
                rows={2}
                cols={20}
                name="addressNBFC"
                value={formData.addressNBFC}
                onChange={handleChange}
                style={{ resize: "none" }}
              />
              {errors.addressNBFC && (
                <div className="text-danger">{errors.addressNBFC}</div>
              )}
            </div>
          </div>

          <div className="col-md-6 changeProductPro">
            <div className="mb-3">
              <label htmlFor="creditLimit" className="form-label">
              Maximum Order Approval Amount<span>*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Maximum Order Approval Amount"
                className="form-control"
                id="name"
                name="maxOrderApprovalAmount"
                value={formData.maxOrderApprovalAmount}
                onChange={handleChange}
                aria-describedby="textHelp"
              />
              {errors.maxOrderApprovalAmount && (
                <div className="text-danger">{errors.maxOrderApprovalAmount}</div>
              )}
            </div>
          </div>
        </div>
        <br />

        {/* Grievance Details */}
        <div className="row">
          <h4 className="programDetailsDekho">
            Grievance Rederssal Person Details
          </h4>
          <hr />

          <div className="col-md-6 changeProductPro">
            <div className="mb-3">
              <label htmlFor="creditLimit" className="form-label">
                Name<span>*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Officer Name"
                className="form-control"
                id="name"
                name="grivenceName"
                value={formData.grivenceName}
                onChange={handleChange}
                aria-describedby="textHelp"
              />
              {errors.grivenceName && (
                <div className="text-danger">{errors.grivenceName}</div>
              )}
            </div>
          </div>

          <div className="col-md-6 changeProductPro">
            <div className="mb-3">
              <label htmlFor="creditLimit" className="form-label">
                Email <span>*</span>
              </label>
              <input
                type="email"
                placeholder="Enter Email Address"
                className="form-control"
                id="name"
                name="grivenceEmail"
                value={formData.grivenceEmail}
                onChange={handleChange}
                aria-describedby="textHelp"
              />
              {errors.grivenceEmail && (
                <div className="text-danger">{errors.grivenceEmail}</div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 changeProductPro">
            <div className="mb-3">
              <label htmlFor="creditLimit" className="form-label">
                Phone/Mobile Number<span>*</span>
              </label>
              <input
                type="number"
                placeholder="Enter Phone/Mobile Number"
                className="form-control"
                id="name"
                name="grivenceMobileno"
                value={formData.grivenceMobileno}
                onChange={handleChange}
                aria-describedby="textHelp"
              />
              {errors.grivenceMobileno && (
                <div className="text-danger">{errors.grivenceMobileno}</div>
              )}
            </div>
          </div>

          <div className="col-md-6 changeProductPro">
            <div className="mb-3">
              <label htmlFor="creditLimit" className="form-label">
                Address<span>*</span>
              </label>
              <textarea
                placeholder="Enter Address"
                className="form-control"
                rows={2}
                cols={20}
                name="grivenceAddress"
                value={formData.grivenceAddress}
                onChange={handleChange}
                style={{ resize: "none" }}
              />
              {errors.grivenceAddress && (
                <div className="text-danger">{errors.grivenceAddress}</div>
              )}
            </div>
          </div>
        </div>
        <br />
        <div className="text-center">
          <button type="submit" className="btn btn-success text-center">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddFinancier;
